import { render, staticRenderFns } from "./NutritionInfo.vue?vue&type=template&id=bdbd3890&scoped=true&"
import script from "./NutritionInfo.vue?vue&type=script&lang=js&"
export * from "./NutritionInfo.vue?vue&type=script&lang=js&"
import style0 from "./NutritionInfo.vue?vue&type=style&index=0&id=bdbd3890&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdbd3890",
  null
  
)

export default component.exports